module.exports = __webpack_public_path__ + "static/05-compassion-ceb460081b86c0d9be8225e846775ac8.png";